export default "__VITE_ASSET__BhE0IjUg__"